import { useTranslation } from "react-i18next";

export const useSharedTranslation = () => {
    const { t: tShared, ...rest } = useTranslation("shared");

    return {
        tShared,
        ...rest
    };
};
